 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		26: 0
 	};

 	var deferredModules = [];

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}


 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	__webpack_require__(352).initialize({
 		"!!/srv/zulip-npm-cache/34c029af70b5991510af6d2a74087645b48f04cf/node_modules/raw-loader/index.js!moment-timezone/builds/moment-timezone-with-data.min.js": 387,
 		"!!/srv/zulip-npm-cache/34c029af70b5991510af6d2a74087645b48f04cf/node_modules/raw-loader/index.js!moment/min/moment.min.js": 385,
 		"-!./tools/debug-require": 352,
 		"-!./tools/debug-require.js": 352,
 		"-!handlebars/dist/cjs/handlebars.runtime.js": 367,
 		"-!jquery": 353,
 		"-!jquery/dist/jquery.js": 353,
 		"-!sortablejs/Sortable.js": 388,
 		"-!underscore/underscore.js": 355,
 		"./static/assets/icons/zulip-icons.font.js": 391,
 		"./static/js/blueslip": 169,
 		"./static/js/blueslip.js": 169,
 		"./static/js/blueslip_stacktrace": 359,
 		"./static/js/bundles/common.js": 55,
 		"./static/js/bundles/portico.js": 40,
 		"./static/js/common.js": 383,
 		"./static/js/csrf.js": 357,
 		"./static/js/i18n.js": 45,
 		"./static/js/page_params.js": 356,
 		"./static/js/portico/google-analytics.js": 31,
 		"./static/js/portico/header.js": 48,
 		"./static/js/portico/tabbed-instructions.js": 124,
 		"./static/styles/portico/landing-page.scss": 161,
 		"./static/styles/portico/portico-styles.scss": 68,
 		"./static/styles/pygments.scss": 393,
 		"./static/templates/blueslip_stacktrace.hbs": 310,
 		"./static/third/bootstrap/css/bootstrap-btn.css": 389,
 		"./static/third/bootstrap/css/bootstrap-responsive.css": 251,
 		"./static/third/bootstrap/css/bootstrap.css": 250,
 		"./static/third/bootstrap/js/bootstrap.js": 382,
 		"./tools/debug-require": 351,
 		"./tools/debug-require.js": 351,
 		"@uppy/core/dist/style.css": 394,
 		"@uppy/progress-bar/dist/style.css": 395,
 		"core-js/features/promise": 318,
 		"core-js/features/symbol": 330,
 		"core-js/modules/es.array.concat": 34,
 		"core-js/modules/es.array.filter": 16,
 		"core-js/modules/es.array.find": 12,
 		"core-js/modules/es.array.for-each": 32,
 		"core-js/modules/es.array.from": 10,
 		"core-js/modules/es.array.includes": 18,
 		"core-js/modules/es.array.index-of": 44,
 		"core-js/modules/es.array.iterator": 2,
 		"core-js/modules/es.array.join": 28,
 		"core-js/modules/es.array.last-index-of": 117,
 		"core-js/modules/es.array.map": 15,
 		"core-js/modules/es.array.reverse": 107,
 		"core-js/modules/es.array.slice": 7,
 		"core-js/modules/es.function.name": 5,
 		"core-js/modules/es.map": 17,
 		"core-js/modules/es.object.assign": 35,
 		"core-js/modules/es.object.keys": 89,
 		"core-js/modules/es.object.to-string": 1,
 		"core-js/modules/es.promise": 114,
 		"core-js/modules/es.regexp.exec": 14,
 		"core-js/modules/es.regexp.to-string": 6,
 		"core-js/modules/es.set": 50,
 		"core-js/modules/es.string.includes": 23,
 		"core-js/modules/es.string.iterator": 3,
 		"core-js/modules/es.string.link": 192,
 		"core-js/modules/es.string.match": 72,
 		"core-js/modules/es.string.replace": 26,
 		"core-js/modules/es.string.split": 25,
 		"core-js/modules/es.string.starts-with": 56,
 		"core-js/modules/es.symbol": 8,
 		"core-js/modules/es.symbol.description": 9,
 		"core-js/modules/es.symbol.iterator": 11,
 		"core-js/modules/web.dom-collections.for-each": 33,
 		"core-js/modules/web.dom-collections.iterator": 4,
 		"error-stack-parser": 308,
 		"font-awesome/css/font-awesome.css": 390,
 		"ga-gtag": 21,
 		"handlebars/dist/cjs/handlebars.runtime.js": 138,
 		"jquery": 123,
 		"jquery/dist/jquery.js": 123,
 		"moment-timezone/builds/moment-timezone-with-data.min.js": 386,
 		"moment/min/moment.min.js": 384,
 		"regenerator-runtime/runtime": 104,
 		"simplebar/dist/simplebar.css": 252,
 		"sortablejs/Sortable.js": 249,
 		"source-map": 360,
 		"source-sans-pro/source-sans-pro.css": 392,
 		"stackframe": 240,
 		"stacktrace-gps": 309,
 		"underscore/underscore.js": 354
 	});
 	// add entry module to deferred list
 	deferredModules.push([418,2,4,0,1,3,5]);
 	// run deferred modules when ready
 	return checkDeferredModules();
